import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "./lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const t = localStorage.getItem("pamit_token");
    if (!t) return setUser(false);
    API.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("pamit_token");
        setUser(false);
      });
  }, []);
  const keluar = () => {
    localStorage.removeItem("pamit_token");
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, keluar }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

const BERANDA_PERAN = { admin: "/buku", pemilik: "/buku", hr: "/pamit", manajer: "/dampak" };

const BERHAK = {  admin: ["buku", "permintaan", "sapuan", "sistem", "pamit", "dampak", "dasar", "ruang-kerja"],
  pemilik: ["buku", "permintaan"],
  hr: ["pamit"],
  manajer: ["buku", "dampak"],
};

export function Require({ area, children }) {
  const { user } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (user === false) nav("/masuk", { replace: true });
  }, [user, nav]);
  if (!user) return null;
  if (!BERHAK[user.peran]?.includes(area))
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-4 text-center" data-testid="akses-ditolak">
        <p className="label-kecil">Layar ini bukan untuk peran Anda</p>
        <h1 className="mt-4 text-3xl font-bold">Belum bisa dibuka</h1>
        <p className="mt-3 text-sm text-muted-foreground max-w-md">
          Peran Anda ({user.peran}) tidak berhak membuka layar ini. Pembatasannya ditegakkan di server,
          bukan hanya disembunyikan di tampilan.
        </p>
        <button data-testid="btn-kembali-layar-saya" onClick={() => nav(BERANDA_PERAN[user.peran] || "/")}
          className="tombol-utama mt-7 px-5 py-2.5 rounded text-sm">
          Kembali ke layar saya
        </button>
      </div>
    );
  return children;
}
